import Icon from '../components/Icon.vue'

Icon.register({
  'caret-down': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1l-128.6 128.7c-7.8 7.8-20.5 7.8-28.3 0l-128.6-128.7c-12.6-12.6-3.7-34.1 14.1-34.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-down.js
// module id = 1150
// module chunks = 0